import { z } from "zod";

const datePattern = /^\d{4}-\d{2}-\d{2}$/;

export const availabilityWindowSchema = z
  .object({
    date: z.string().regex(datePattern, "Expected YYYY-MM-DD"),
    anyTime: z.boolean(),
    startMinute: z.number().int().min(0).max(1439).optional(),
    endMinute: z.number().int().min(1).max(1440).optional(),
  })
  .superRefine((w, ctx) => {
    if (w.anyTime) {
      if (w.startMinute != null || w.endMinute != null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["startMinute"],
          message: "Omit times when anyTime is true.",
        });
      }
      return;
    }
    if (w.startMinute == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["startMinute"],
        message: "Start time is required.",
      });
    }
    if (w.endMinute == null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endMinute"],
        message: "End time is required.",
      });
    }
    if (
      w.startMinute != null &&
      w.endMinute != null &&
      w.endMinute <= w.startMinute
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endMinute"],
        message: "End must be after start.",
      });
    }
  });
export type AvailabilityWindow = z.infer<typeof availabilityWindowSchema>;

export const shiftSearchRequestSchema = z.object({
  windows: z.array(availabilityWindowSchema).min(1, "Select at least one day."),
});
export type ShiftSearchRequest = z.infer<typeof shiftSearchRequestSchema>;
